export enum BasketballStatId {
  Points = 75,
  FieldGoalsScored = 54,
  FieldGoalsAttempts = 55,
  FieldGoalsPercentage = 100,
  FourPointsScored = 1466,
  FourPointsAttempts = 1468,
  FourPointsPercentage = 1469,
  ThreePointsScored = 56,
  ThreePointsAttempts = 57,
  ThreePointsPercentage = 102,
  TwoPointsScored = 58,
  TwoPointsAttempts = 59,
  TwoPointsPercentage = 101,
  FreeThrowsScored = 60,
  FreeThrowsAttempts = 61,
  FreeThrowsPercentage = 103,
  ReboundsOffensive = 62,
  ReboundsDefensive = 63,
  ReboundsTotal = 64,
  Fouls = 22,
  Assists = 41,
  Steals = 70,
  Blocks = 71,
  Turnovers = 72,
  Appearance = 35,
  MinutesInPlay = 837,
  StartingLineup = 838,
  PlusMinus = 83,
  WillNotPlay = 1239,
  Substitute = 1240,
  FoulBonus = 73,
  CurrentQuarterFouls = 1122,
}
